module.exports = __webpack_public_path__ + "static/media/ggHack.d704d0de.jpg";